module.exports = __webpack_public_path__ + "img/illustrations-SDK.123ef99a.svg";